import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No. El sistema está diseñado para empezar desde cero.'
  }, {
    q: '¿Funciona en mi ciudad?',
    a: 'Sí. El piso epoxi se aplica en todo el país, tanto en viviendas como en industria.'
  }, {
    q: '¿Necesito herramientas costosas?',
    a: 'No al inicio. Aprendés qué comprar y en qué no gastar de más.'
  }, {
    q: '¿Cuándo recupero la inversión?',
    a: 'Muchos alumnos lo hacen con su primer trabajo pequeño.'
  }, {
    q: '¿Tengo acceso para siempre?',
    a: 'Sí. Acceso ilimitado al contenido.'
  }];
  return <section className="py-16 px-4 bg-[#111]" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-white" data-id="element-70">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-71">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-800 rounded-lg overflow-hidden" data-id="element-72">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 md:p-6 bg-[#1a1a1a] hover:bg-[#222] transition-colors text-left" data-id="element-73">
                <span className="font-bold text-lg text-white" data-id="element-74">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-amber-500" data-id="element-75" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-76" />}
              </button>

              {openIndex === index && <div className="p-4 md:p-6 bg-[#141414] border-t border-gray-800" data-id="element-77">
                  <p className="text-gray-300 text-lg" data-id="element-78">{faq.a}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}